//用户登陆信息
export const setUser = (state, { currentUser_name, user_token, user_id, user_mail, user_phone }) => {
  // 在这里把用户名和token保存起来
  localStorage.setItem("currentUser_name", currentUser_name);
  localStorage.setItem("currentUser_token", user_token);
  localStorage.setItem("currentUser_id", user_id);
  localStorage.setItem("currentUser_mail", user_mail);
  localStorage.setItem("currentUser_phone", user_phone);

  state.currentUser.UserName = currentUser_name;
  state.currentUser.UserToken = user_token;
  state.currentUser.UserId = user_id;
  state.currentUser.UserMail = user_mail;
  state.currentUser.UserPhone = user_phone;
}
export const setUserMail = (state, { userId, mail }) => {
  // 在这里把用户名和token保存起来
  localStorage.setItem("currentUser_id", userId);
  localStorage.setItem("currentUser_mail", mail);

  state.currentUser.UserMail = mail;
  state.currentUser.UserId = userId;
}
export const setUserPhone = (state, phone) => {
  localStorage.setItem("currentUser_phone", phone);
  state.currentUser.UserPhone = phone;
}

export const setOnlyUserEmail = (state, { mail }) => {
  // 在这里把用户名和token保存起来
  localStorage.setItem("currentUser_mail", mail);
  state.currentUser.UserMail = mail;

}

export const LoginOut = (state) => {
  // 在这里把用户名和token保存起来 localStorage.removeItem('key')
  localStorage.removeItem("currentUser_name");
  localStorage.removeItem("currentUser_token");
  state.currentUser.UserName = "";
  state.currentUser.UserToken = "";
  state.currentUser.UserId = "";
  state.currentUser.UserMail = "";
}
export const saveKeyword = (state, keywords) => {
  // 在这里把用户名和token保存起来 localStorage.removeItem('key')
  state.keywords = keywords;
}
export const saveKeywordTime = (state) => {
  // 在这里把用户名和token保存起来 localStorage.removeItem('key')
  state.keywordtime = new Date().getTime();
}



// 保存当前菜单栏的路径
export const savePath = (state, pathName) => {
  state.pathName = pathName;
};

// 保存当前点击的数据源
export const saveCurrDbSource = (state, currDbSource) => {
  state.currDbSource = currDbSource;
};

// 保存当前点击的元数据
export const saveCurrJobData = (state, currJobData) => {
  state.currJobData = null;
  state.currJobData = currJobData;
};

// 保存所有数据源
export const saveDbSource = (state, DbSource) => {
  state.DbSource = DbSource;
};

// 保存搜索后选择的那一条元数据
export const saveSelectJobMeta = (state, selectJobMeta) => {
  state.selectJobMeta = selectJobMeta;
};

// 保存搜索的那一类专题
export const saveSpecialSubject = (state, specialSubject) => {
  state.specialSubject = specialSubject;
  state.selectJobMeta = {};
};

// 保存复制的元数据（名称为空）
export const saveDuplicateJobMeta = (state, duplicateJobMeta) => {
  state.duplicateJobMeta = duplicateJobMeta;
};

// 保存查询商品的条件
export const saveGoodsWhere = (state, info) => {
  state.conditions = info;
};

// 对比列表操作（最多保留 4 条）
export const addCompareGoods = (state, goods) => {
  if (!goods || !goods.id) return;
  // 用 String 比较，避免不同接口返回的 id 类型不一致（数字/字符串）导致去重失效
  if (state.compareList.some(item => String(item.id) === String(goods.id))) return;
  if (goods.idx_cid1 && state.compareList.length > 0) {
    if (state.compareList.some(item => item.idx_cid1 && item.idx_cid1 != goods.idx_cid1)) {
      return;
    }
  }
  if (state.compareList.length >= 4) {
    state.compareList.shift();
  }
  console.log(goods,'goodsduibi');
  state.compareList.push(goods);
  state.compareListVersion++; // 版本号+1，通知对比页重新拉取数据
  localStorage.setItem('compareList', JSON.stringify(state.compareList));
};

export const removeCompareGoods = (state, goodsId) => {
  // 用 String 比较，避免 id 类型不一致导致删除匹配不到
  const idx = state.compareList.findIndex(item => String(item.id) === String(goodsId));
  if (idx > -1) {
    state.compareList.splice(idx, 1);
    state.compareListVersion++; // 版本号+1，通知对比页重新拉取数据
  }
  localStorage.setItem('compareList', JSON.stringify(state.compareList));
};

export const clearCompareGoods = (state) => {
  state.compareList = [];
  state.compareListVersion++; // 版本号+1，通知对比页重新拉取数据
  localStorage.setItem('compareList', JSON.stringify(state.compareList));
};

// 从 localStorage 同步对比列表（多标签页场景：切回页面/其他页面修改时刷新，避免相互覆盖）
export const syncCompareFromStorage = (state) => {
  let list = [];
  try {
    list = JSON.parse(localStorage.getItem('compareList') || '[]');
  } catch (e) {
    list = [];
  }
  // 内容没变化就不更新，避免触发不必要的页面刷新
  if (JSON.stringify(list) === JSON.stringify(state.compareList)) return;
  state.compareList = list;
  state.compareListVersion++; // 版本号+1，通知对比页重新拉取数据
};



// WEBPACK FOOTER //
// ./src/store/mutations.js